import logger from '@w/utils/logger';
import urlExt from '@w/utils/url';
import VisibilityObserver from '@w/utils/visibility-observer';

const isDebug = Number(urlExt.getQuery('debug')) === 2;

function showOverlay(text, target, type) {
  const newDiv = document.createElement('div');
  newDiv.className = `overlay ${type === 2 ? 'special' : 'normal'}`;
  newDiv.innerHTML = `<div class="text">${text}</div>`;
  target.className = target.className + ' overlay-wrapper';
  target.appendChild(newDiv);
}

function paramsParser(params) {
  if (params.match(/&/) !== null) {
    params = urlExt.queryToJson(params);
  } else {
    params = { name: params };
  }
  return params;
}

function loggerPVHandler(value, el) {
  const loggerContent = paramsParser(value);
  logger.send({
    type: 'pv',
    ...loggerContent
  });
  isDebug && showOverlay(value, el, 1);
}

function loggerClickHandler(target, el, value) {
  const loggerClickHits = 'loggerClickHits' in el ? el.dataset.loggerClickHits : 1;
  el.dataset.loggerClickHits = loggerClickHits;
  const loggerContent = paramsParser(value);
  logger.send({
    type: 'click',
    offsetX: target.offsetX,
    offsetY: target.offsetY,
    name: value,
    hits: loggerClickHits,
    ...loggerContent
  });
  isDebug && showOverlay(value, el, 2);
}

const dirLogger = {
  loggerPV: {
    bind: (el, { value, arg }, vnode) => {
      if (!value) {
        return;
      }
      if (typeof IntersectionObserver === 'undefined') {
        console.warn('[loggerPV] IntersectionObserver API is not available in your browser.')  // eslint-disable-line
      } else {
        el._kd_logger = new VisibilityObserver(el, arg || '', vnode, visible => {  // eslint-disable-line
          visible && loggerPVHandler(value, el);
        });
      }
    },
    unbind: el => {
      const observer = el._kd_logger;
      if (observer) {
        observer.destroy();
        delete el._kd_logger;
      }
    },
    update: (el, { value, oldValue, arg }, vnode) => {
      if (value === oldValue) {
        return;
      }
      const observer = el._kd_logger;
      if (!value) {
        this.unbind(el);
        return;
      }
      if (observer) {
        observer.create(el, vnode, () => {
          loggerPVHandler(value, el);
        });
      } else {
        this.bind(el, { value, arg }, vnode);
      }
    }
  },
  loggerClick: {
    bind: (el, { value }, vnode) => {
      vnode.context.$nextTick(() => {
        el.addEventListener(
          'click',
          target => {
            loggerClickHandler(target, el, value);
          },
          false
        );
      });
    },
    unbind: (el, { value }) => {
      const loggerClickHits = el.dataset.loggerClickHits;
      if (loggerClickHits) {
        el.removeEventListener(
          'click',
          target => {
            loggerClickHandler(target, el, value);
          },
          false
        );
      }
    },
    update: (el, { value, oldValue }, vnode) => {
      if (value === oldValue) {
        return;
      }
      const loggerClickHits = el.dataset.loggerClickHits;
      if (!value) {
        this.unbind(el, { value });
        return;
      }
      if (!loggerClickHits) {
        this.bind(el, { value }, vnode);
      }
    }
  }
};

export default dirLogger;
